/**
 * The double-billing warning (fieldiq-api EW-6, Jason 2026-11-01: warn, don't
 * refuse). Drawn where a generator answered 409 billing_overlap: the API's
 * own sentence, and "Confirm and invoice anyway", which resends the same
 * request with confirm_overlap: true. The API then records who confirmed on
 * the invoice. Nothing here decides whether an overlap exists.
 */
import { AlertTriangle } from 'lucide-react';
import { EW_SECONDARY } from '../EwBits';

export function EwOverlapConfirm({ message, pending, onConfirm, onCancel }: {
  message: string;
  pending: boolean;
  onConfirm: () => void;
  onCancel?: () => void;
}) {
  return (
    <div role="alert" className="rounded-lg border border-fi-amber/40 bg-fi-amber/10 px-3 py-2 text-sm text-fieldiq-text" data-testid="ew-overlap-warning">
      <p className="flex items-start gap-2">
        <AlertTriangle className="mt-0.5 size-4 shrink-0 text-fi-signal-amber" aria-hidden="true" />
        <span>{message}</span>
      </p>
      <div className="mt-2 flex flex-wrap gap-2">
        <button type="button" className={EW_SECONDARY} onClick={onConfirm} disabled={pending} data-testid="ew-overlap-confirm">
          {pending ? 'Creating…' : 'Confirm and invoice anyway'}
        </button>
        {onCancel && (
          <button type="button" className={EW_SECONDARY} onClick={onCancel} disabled={pending}>
            Cancel
          </button>
        )}
      </div>
    </div>
  );
}

/** A read-time note: the job is already billed another way (before the click). */
export function EwOverlapNote({ text, testId = 'ew-overlap-note' }: { text: string; testId?: string }) {
  return (
    <p role="note" className="flex items-start gap-2 text-sm text-fieldiq-text" data-testid={testId}>
      <AlertTriangle className="mt-0.5 size-4 shrink-0 text-fi-signal-amber" aria-hidden="true" />
      <span>{text}</span>
    </p>
  );
}
